import { render, staticRenderFns } from "./AnredenEdit.vue?vue&type=template&id=06402a4b&scoped=true"
import script from "./AnredenEdit.vue?vue&type=script&lang=js"
export * from "./AnredenEdit.vue?vue&type=script&lang=js"
import style0 from "./AnredenEdit.vue?vue&type=style&index=0&id=06402a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06402a4b",
  null
  
)

export default component.exports